var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "saas-page linear-log-page" },
    [
      _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
        _c("div", { staticClass: "saas-hero__main" }, [
          _c(
            "p",
            { staticClass: "saas-hero__crumb" },
            [
              _c("router-link", { attrs: { to: "/home" } }, [
                _vm._v(_vm._s(_vm.trans("general.home"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("activity.activity_log")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "linear-eyebrow" }, [
            _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "saas-hero__title" }, [
            _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "linear-command-actions" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.showFilterPanel = !_vm.showFilterPanel
                },
              },
            },
            [
              _c("admin-icon", { attrs: { name: "sliders" } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showFilterPanel
          ? _c("div", { staticClass: "card-saas linear-filter-card" }, [
              _c("div", { staticClass: "linear-section-head" }, [
                _c("div", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.users,
                          expression: "users",
                        },
                      ],
                      staticClass: "form-group",
                    },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("user.user"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterActivityLogForm.user_id,
                              expression: "filterActivityLogForm.user_id",
                            },
                          ],
                          staticClass: "custom-select col-12",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterActivityLogForm,
                                "user_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.select_one"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.users, function (user) {
                            return _c(
                              "option",
                              { key: user.id, domProps: { value: user.id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      user.profile.first_name +
                                        " " +
                                        user.profile.last_name
                                    ) +
                                    "\n                          "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          "start-date":
                            _vm.filterActivityLogForm.created_at_start_date,
                          "end-date":
                            _vm.filterActivityLogForm.created_at_end_date,
                        },
                        on: {
                          "update:startDate": function ($event) {
                            return _vm.$set(
                              _vm.filterActivityLogForm,
                              "created_at_start_date",
                              $event
                            )
                          },
                          "update:start-date": function ($event) {
                            return _vm.$set(
                              _vm.filterActivityLogForm,
                              "created_at_start_date",
                              $event
                            )
                          },
                          "update:endDate": function ($event) {
                            return _vm.$set(
                              _vm.filterActivityLogForm,
                              "created_at_end_date",
                              $event
                            )
                          },
                          "update:end-date": function ($event) {
                            return _vm.$set(
                              _vm.filterActivityLogForm,
                              "created_at_end_date",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.activity_logs.total
        ? _c(
            "div",
            { staticClass: "admin-list-table-card linear-table-card mt-3" },
            [
              _c(
                "div",
                {
                  staticClass: "linear-section-head linear-section-head--table",
                },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.trans("activity.activity")))]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table admin-data-table linear-dense-table mb-0",
                  },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [
                            _vm._v(_vm._s(_vm.trans("activity.user"))),
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(_vm.trans("activity.ip")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.trans("activity.user_agent"))),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.trans("activity.activity"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "sortable-th",
                            {
                              attrs: {
                                field: "created_at",
                                "sort-by": _vm.filterActivityLogForm.sort_by,
                                order: _vm.filterActivityLogForm.order,
                              },
                              on: { sort: _vm.sortList },
                            },
                            [_vm._v(_vm._s(_vm.trans("activity.date_time")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticClass: "admin-table-actions-cell" },
                            [_vm._v(_vm._s(_vm.trans("general.actions")))]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.activity_logs.data, function (activity_log) {
                        return _c("tr", { key: activity_log.id }, [
                          _c("td", [
                            _c("span", {
                              staticClass: "linear-table-primary",
                              domProps: {
                                textContent: _vm._s(
                                  activity_log.user.profile.first_name +
                                    " " +
                                    activity_log.user.profile.last_name
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", {
                              staticClass: "linear-mono",
                              domProps: {
                                textContent: _vm._s(activity_log.ip),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", {
                              staticClass:
                                "linear-table-muted linear-table-truncate",
                              domProps: {
                                textContent: _vm._s(activity_log.user_agent),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "span",
                              { staticClass: "linear-table-primary" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "activity." + activity_log.activity,
                                      {
                                        activity: _vm.trans(
                                          "activity." + activity_log.module
                                        ),
                                      }
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", { staticClass: "linear-table-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(activity_log.created_at)
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "admin-table-actions-cell" },
                            [
                              _c(
                                "table-row-action-dropdown",
                                [
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      directives: [
                                        {
                                          name: "confirm",
                                          rawName: "v-confirm",
                                          value: {
                                            ok: _vm.confirmDelete(activity_log),
                                          },
                                          expression:
                                            "{ok: confirmDelete(activity_log)}",
                                        },
                                      ],
                                      staticClass: "admin-row-actions__danger",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "trash" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("general.delete")) +
                                          "\n                                "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "admin-table-pagination-wrap" },
                [
                  _c("pagination-record", {
                    attrs: {
                      "page-length": _vm.filterActivityLogForm.page_length,
                      records: _vm.activity_logs,
                    },
                    on: {
                      "update:pageLength": function ($event) {
                        return _vm.$set(
                          _vm.filterActivityLogForm,
                          "page_length",
                          $event
                        )
                      },
                      "update:page-length": function ($event) {
                        return _vm.$set(
                          _vm.filterActivityLogForm,
                          "page_length",
                          $event
                        )
                      },
                      updateRecords: _vm.getActivityLogs,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.activity_logs.total
        ? _c(
            "div",
            {
              staticClass:
                "admin-list-table-card admin-empty-state linear-empty-state mt-3",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "list" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-empty-state__text" }, [
                  _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }